export type StatusTypeValue = "OPENED" | "CLOSED" | "PENDING" | "NOT_INTEGRATED";
export type StatusType = StatusTypeValue | null;

export interface StatusConfig {
  label: string;
  color: string;
  bgColor: string;
  textColor: string;
}

export interface FixedColumn<T> {
  key: keyof T;
  header: string;
  width?: string;
  render?: (value: T[keyof T], row: T) => React.ReactNode;
}

export interface StatusGridRow {
  id: string | number;
  [key: string]: unknown;
}

export interface StatusGridTableProps<T extends StatusGridRow> {
  data: T[];
  fixedColumns: FixedColumn<T>[];
  dateColumns: string[];
  getStatus: (row: T, date: string) => StatusType;
  onCellClick?: (row: T, date: string, status: StatusType) => void;
  title?: string;
  isLoading?: boolean;
  isFetching?: boolean;
  emptyMessage?: string;
  statusConfig?: Partial<Record<StatusTypeValue, StatusConfig>>;
  highlightStatuses?: string[];
}

export const DEFAULT_STATUS_CONFIG: Record<NonNullable<StatusType>, StatusConfig> = {
  OPENED: {
    label: "AB",
    color: "#ef4444",
    bgColor: "bg-red-500",
    textColor: "text-white",
  },
  PENDING: {
    label: "AG",
    color: "#E3B400",
    bgColor: "bg-yellow-500",
    textColor: "text-yellow-900",
  },
  CLOSED: {
    label: "OK",
    color: "#00AC4F",
    bgColor: "bg-emerald-500",
    textColor: "text-white",
  },
  NOT_INTEGRATED: {
    label: "-",
    color: "#9ca3af",
    bgColor: "bg-gray-400",
    textColor: "text-white",
  },
};
